import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-detalles-campus',
  templateUrl: './detalles-campus.component.html',
  styleUrls: ['./detalles-campus.component.scss']
})
export class DetallesCampusComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DetallesCampusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  closeModal(){
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
